<template>
  <VContent>
    <template slot="right">
      <span>الأقسام</span>
    </template>
    <template slot="left">
      <b-button variant="info" size="md" class="text-light" v-b-modal.department-modal>اضافة</b-button>
    </template>
    <template slot="content">
      <b-table :items="items" :fields="fields" :tbody-transition-props="transProps" tbody-tr-class="text-muted"
        responsive table-class="table-font h-100">
        <template #cell(id)="data">
          {{ (page - 1) * 10 + data.index + 1 }}
        </template>
        <template v-slot:cell(governate)="{ item }">
          <div class="p-2 rounded-pill orange">
            {{ governateName(item.governate) }}
          </div>
        </template>
        <template v-slot:cell(address)="{ item }">
          <div class="p-2 rounded-pill green">{{ item.address }}</div>
        </template>
        <template v-slot:cell(created_at)="{ item }">{{
          new Date(item.created_at).toISOString().slice(0, 10)
        }}</template>
        <template v-slot:cell(status)="{ item }">
          <div class="p-2 rounded-pill " :class="{
            'green': item.status === 1,
            'error': item.status === 2,
            'pending': item.status !== 1 && item.status !== 2
          }">
            {{ item.status === 1 ? "تم القبول" : item.status === 2 ? "تم الرفض" : item.status === 0 ? "جاري المراجعة" :
              "" }}
          </div>
        </template>
        <template v-slot:cell(actions)="{ item }">
          <b-dropdown size="lg" variant="link" no-caret>
            <template #button-content>
              <b-icon icon="three-dots" animation="cylon"></b-icon>
            </template>
            <b-dropdown-item @click="getByID(item, false)">
              <b-icon icon="pencil-square" scale="0.5" class="ml-2"></b-icon>
              تعديل</b-dropdown-item>
            <b-dropdown-item @click="remove(item.id)">
              <b-icon icon="archive" scale="0.5" class="ml-2"></b-icon>
              حذف</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </template>
    <template slot="modals">
      <DepartmentModal :readonly="readonly" @close="modalClosed()"></DepartmentModal>
    </template>
    <template slot="bottom">
      <b-pagination v-model="page" :current-page="meta.current_page" :per-page="meta.per_page"
        :total-rows="meta.last_page * meta.per_page"></b-pagination>
    </template>
  </VContent>
</template>

<script>
import DepartmentModal from "./components/department";
import {
  successAlert,
  errorAlert,
  showAlertWithConfirm,
  ImageURL,
} from "@/utils/helper";

export default {
  components: { DepartmentModal },
  data() {
    return {
      id: null,
      page: 1,
      readonly: false,
      item: null,
      transProps: {
        name: "flip-list",
      },
      fields: [
        {
          key: "id",
          label: "أ",
          sortable: true,
        },
        {
          key: "name",
          label: "أسم جهاز الصرف",
          sortable: true,
        },
        {
          key: "governate",
          label: "المحافظة",
          sortable: true,
        },
        {
          key: "phone",
          label: "رقم الهاتف",
          sortable: true,
        },
        {
          key: "address",
          label: "العنوان",
          sortable: true,
        },
        {
          key: "created_at",
          label: "تاريخ  الأنضمام",
          sortable: true,
        },
        {
          key: "status",
          label: "الحالة",
          sortable: true,
        },
        {
          key: "actions",
          label: "العمليات",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    items() {
      return this.$store.state.banks.branches.list;
    },
    meta() {
      return this.$store.state.banks.branches.meta;
    },
    governates() {
      return this.$store.state.banks.branches.governates;
    },
  },
  watch: {
    page() {
      this.getAll();
    },
    $route() {
      this.getType();
    },
  },
  mounted() {
    this.getType();
  },
  methods: {
    getAll() {
      this.$store.dispatch("banks/branches/get", this.page);
    },
    getByID(item, status) {
      this.readonly = status;
      this.$store.commit("banks/branches/SET_BRANCH", item);
      this.$bvModal.show("department-modal");
    },
    getType() {
      this.id = this.$route.meta.id;
      this.$store.commit("banks/branches/SET_TYPE", this.id);
      this.getAll();
    },
    remove(id) {
      showAlertWithConfirm().then((response) => {
        if (response.isConfirmed) {
          this.$store
            .dispatch("banks/branches/delete", id)
            .then(() => {
              successAlert();
              this.$store.commit("banks/branches/DELETE_BRANCH", id);
            })
            .catch((error) =>
              errorAlert(
                error.response ? error.response.data.message : "فشل الحذف"
              )
            );
        }
      });
    },
    ImageURL(item) {
      return item.image ? item.image : ImageURL("user.jpg");
    },
    governateName(id) {
      return isNaN(parseInt(id)) == true
        ? id
        : this.governates.find((x) => x.value === parseInt(id)).text;
    },
    modalClosed() {
      this.readonly = false;
      this.$store.commit("banks/branches/SET_TYPE", this.id);
    },
  },
};
</script>

<style lang="scss">
td[aria-colindex="4"] {
  direction: ltr;
}
</style>
